import { useEffect, useState } from "react";

import {
  PaymentsPayoutService,
  type PayoutResponse,
} from "@/modules/dashboard/dispersions/services/paymentsPayout.service";

interface PayoutRead {
  id: string;
  payout: PayoutResponse | null;
}

// A failed read leaves the payout null and the caller shows only what the leg itself carries.
export function useStatementPayout(payoutId: string | null): PayoutResponse | null {
  const [read, setRead] = useState<PayoutRead | null>(null);

  useEffect(() => {
    if (!payoutId) return;
    let cancelled = false;
    PaymentsPayoutService.getPayout(payoutId)
      .then(({ data }) => {
        if (!cancelled) setRead({ id: payoutId, payout: data });
      })
      .catch(() => {
        if (!cancelled) setRead({ id: payoutId, payout: null });
      });
    return () => {
      cancelled = true;
    };
  }, [payoutId]);

  return payoutId && read?.id === payoutId ? read.payout : null;
}
